<template>
  <div>
    <button
      v-tippy="{ content: $t('evaluate_your_experience') }"
      class="customerpulse-trigger z-[100] fixed size-14 bottom-6 end-2 flex justify-center items-center bg-primary rounded-full border border-primary-700 shadow-xl"
      @click="onSurveyClick"
    >
      <i class="text-xl ica-custom-fonts-customer-pulse text-white" aria-hidden="true"></i>
    </button>
    <div id="customerPulseContainer"></div>
  </div>
</template>

<script setup>
import client_config from '@/assets/json/client_config.json'
import { useGlobalStore } from '@/stores/global'

const globalStore = useGlobalStore()

const { customerPulseGeneralSurveyEntityLinkingIdV2, customerPulseGeneralSurveyEntityLinkingId } =
  client_config

const link =
  customerPulseGeneralSurveyEntityLinkingIdV2 || customerPulseGeneralSurveyEntityLinkingId

function onSurveyClick() {
  const el = document.getElementById('customerPulseContainer')
  window.CustomerPulse.render(el, {
    link,
    lang: globalStore.languageId == '2' ? 'en' : 'ar',
    modal: true
  })

  window.CustomerPulse.openModal()
}
</script>

<style lang="scss" scoped></style>
